export const IconAttentionError: {
  name: 'icon_attention_error-37bac840f7d3'
} = {
  name: 'icon_attention_error-37bac840f7d3'
}
